import { InjectionToken } from '@angular/core';
import { VestaConfig } from '../models/vesta-config.model';

export const VESTA_CONFIG = new InjectionToken<VestaConfig>(
  'VESTA_CONFIG'
);
